import React from "react";
import SubsectionBlock from "../../../components/section-items/SubsectionBlock/SubsectionBlock";
import SubsectionTitle from "../../../components/section-items/SubsectionTitle/SubsectionTitle";
import StatisticsBlock from "../StatisticsBlock/StatisticsBlock";
import SubsectionText from "../../../components/section-items/SubsectionText/SubsectionText";

const StatisticsContent = () => {
    return (<SubsectionBlock id={'statistics'} bg={'#eff2e9'}>
        <SubsectionTitle color={'#00008B'}>{'Szczegółowe statystyki zespołu'}</SubsectionTitle>
        <SubsectionText>{'Wszystkie statystyki są pobierane z naszego serwera oraz na bieżąco aktualizowane.'}</SubsectionText>
        <div style={{marginTop: 30, marginBottom: 30, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
            <StatisticsBlock/>
        </div>
    </SubsectionBlock>);
};

export default StatisticsContent;
